import { useEffect, useState } from 'react';
import { Alert, CircularProgress, Grid, Stack, Typography } from '@mui/material';

import { Icons } from '../../assets/icons';
import { useSaveData } from '../../hooks/useSaveData';
import { workOrdersApiKeyStore } from '../../api/workorders-api-key-store';

interface ScheduleReminder {
    token: string;
    option: string;
}

export const ScheduleReminderPage = ({ token, option }: ScheduleReminder) => {

    const [showMessage, setActionMessage] = useState<boolean>(false);
    const [message, setMessage] = useState<any>();
    const { data, isLoading, isSuccess, isError, error, mutateAsync } = useSaveData<any>(workOrdersApiKeyStore.updateScheduleEmail());

    useEffect(() => {
        if (isError && error) {
            const messageAction = {
                type: 'error',
                message: error?.response?.data?.message
            }
            setActionMessage(true);
            setMessage(messageAction)
        }
    }, [isError])

    useEffect(() => {
        if (isSuccess) {
            const messageAction = {
                type: 'success',
                message: data?.message
            }
            setActionMessage(true);
            setMessage(messageAction)
        }
    }, [isSuccess])

    useEffect(() => {
        const scheduleData = {
            token: token,
            option: option,
        };
        mutateAsync({
            data: scheduleData,
        })
    }, []);

    return (
        <>
            <div
                style={{
                    width: '100%',
                    maxWidth: '980px',
                    height: 'calc(100vh - 70px)',
                    margin: '0 auto',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: '1',
                        padding: '15px',
                        flexDirection: 'column',
                    }}
                >
                    <Grid
                        container
                        className=" "
                        justifyContent="center"
                        alignItems="center"
                        style={{ height: '76px', display: 'flex', flexDirection: 'column' }}
                    >
                        <Grid>
                            <Stack className="brandName">
                                {isLoading && (<img style={{ marginBottom: '30px' }} src={Icons.Logo} alt="SI Track" />)}
                            </Stack>
                        </Grid>
                    </Grid>
                    {
                        isLoading && (<Grid><CircularProgress /></Grid>)
                    }
                    {
                        showMessage && (
                            <Grid style={{
                                display: 'flex',
                                flex: '1',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '96%',
                                maxWidth: '800px'
                            }}>
                                {' '}
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '96%',
                                    maxWidth: '800px'
                                }}>
                                    <img style={{ marginBottom: '30px' }} src={Icons.Logo} alt="SI Track" />
                                    <div style={{
                                        padding: '50px',
                                        background: '#fff',
                                        maxWidth: '800px',
                                        width: '96%',
                                        borderRadius: '10px'
                                    }}>
                                        <Alert
                                            className='message-block'
                                            sx={{
                                                "& .MuiAlert-icon": {
                                                    fontSize: 60, // Adjust the icon size
                                                },
                                            }}
                                            severity={message?.type} style={{
                                                background: 'none',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                fontSize: '1.1rem'
                                            }}>
                                            <div style={{ textAlign: 'center' }}>{message?.message}</div>
                                        </Alert>
                                    </div>
                                </div>
                            </Grid>
                        )
                    }
                </div>
                <div style={{ width: '100%', height: '40px' }}>
                    <Typography variant="body2" className="msgfooter text-center">
                        © {new Date().getFullYear()} Specialty Inspectors, LLC. All Right Reserved.
                    </Typography>
                </div>
            </div>
        </>
    );
};
